import {
    useEffect,
    type FC
} from "react";
import type IFieldTitleProps from "./type";
import {
    useFieldOutsideWarning,
    useFieldContext
} from "../../context";
import {
    getFieldChildrenText
} from "../../util";
import Label from "../../../label";

const FieldTitle: FC<IFieldTitleProps> = ({
    customTheme: customThemeProp,
    children,
    ...props
}) => {
    const context = useFieldContext();

    useFieldOutsideWarning({
        isInside: !!context,
        parent: "Field",
        part: "Title"
    });

    const customTheme = customThemeProp ?? context?.customTheme;

    const text = getFieldChildrenText(children);

    const registerPart = context?.registerPart;

    useEffect(() => {
        if(!registerPart) {
            return;
        }

        return registerPart("title", text);
    }, [
        registerPart,
        text
    ]);

    return <Label
        {...props}
        isDisabled={context?.isDisabled ?? false}
        customTheme={customTheme}
        id={context?.titleID}
    >
        {children}
    </Label>;
};
export default FieldTitle;
